import axiosInstanceClient from "../Common/Axios/axiosInstanceClient";
import API from "../Common/Endpoint/serviceConstrants";

// Records site tour interactions for the logged-in customer.
// payload: { memberIdentifier, items: [{ sectionId, sectionContentId? }], status }
export const callSiteTourAuditApi = async (payload) => {
  const { data = {} } = await axiosInstanceClient.post(API.siteTourAudit, payload);
  return data;
};
